import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticate-broker-layout',
  templateUrl: './authenticate-broker-layout.component.html',
  styleUrls: ['./authenticate-broker-layout.component.scss']
})
export class AuthenticateBrokerLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
